import { Badge } from "@mantine/core";
import { ENV_LABEL, env } from "@/config/env";

const ENV_COLOR = {
  dev: "teal",
  staging: "orange",
  production: "red",
} as const;

/**
 * Unmistakable environment indicator (§6.7). Production is red so an operator is
 * never in doubt which system their actions hit.
 */
export function EnvBadge({ size = "lg" }: { size?: string }) {
  return (
    <Badge color={ENV_COLOR[env.eliosEnv]} variant="filled" size={size} radius="sm">
      {ENV_LABEL[env.eliosEnv]}
    </Badge>
  );
}

export function envColor(): string {
  return ENV_COLOR[env.eliosEnv];
}
